import pricesJapan from "./coursePricesJapan.json";

export const FORM_URL_JAPAN =
  "https://docs.google.com/forms/d/e/1FAIpQLScNamc82zH0EVR6CgCcB0WRM-NSm90DeGW2_uGfDK3Oj66wpg/formResponse";

// All languages Koderbox teaches, used wherever the Japan section wants to
// show breadth (hero card, corporate page) rather than just the two course
// tracks that currently have full pricing built out (japanese/english above).
export const ALL_LANGUAGES = [
  { flag: "🇬🇧", label: "英語" },
  { flag: "🇯🇵", label: "日本語" },
  { flag: "🇩🇪", label: "ドイツ語" },
  { flag: "🇫🇷", label: "フランス語" },
  { flag: "🇪🇸", label: "スペイン語" },
  { flag: "🇰🇷", label: "韓国語" },
  { flag: "🇨🇳", label: "中国語" },
];

export const JAPAN_COURSES = {
  japanese: {
    label: "日本語コース",
    flag: "🇯🇵",
    interest: "Japanese (Japan Market)",
    courses: [
      {
        level: "初級",
        title: "JLPT N5",
        duration: "3〜4ヶ月",
        price: pricesJapan.japanese.n5.offerPrice.jpy,
        originalPrice: pricesJapan.japanese.n5.originalPrice.jpy,
        popular: false,
        formLevel: "初級",
      },
      {
        level: "初中級",
        title: "JLPT N4",
        duration: "4〜5ヶ月",
        price: pricesJapan.japanese.n4.offerPrice.jpy,
        originalPrice: pricesJapan.japanese.n4.originalPrice.jpy,
        popular: false,
        formLevel: "中級",
      },
      {
        level: "中級",
        title: "JLPT N3",
        duration: "4〜5ヶ月",
        price: pricesJapan.japanese.n3.offerPrice.jpy,
        originalPrice: pricesJapan.japanese.n3.originalPrice.jpy,
        popular: false,
        formLevel: "上級",
      },
      {
        level: "セット割",
        title: "JLPT N4+N5 セット",
        duration: "6〜8ヶ月",
        price: pricesJapan.japanese.n4n5.offerPrice.jpy,
        originalPrice: pricesJapan.japanese.n4n5.originalPrice.jpy,
        popular: true,
        formLevel: "初級",
      },
    ],
  },
  english: {
    label: "英会話コース",
    flag: "🇬🇧",
    interest: "English (Japan Market)",
    courses: [
      {
        level: "初級",
        title: "英会話ベーシック",
        duration: "3〜4ヶ月",
        price: pricesJapan.english.beginner.offerPrice.jpy,
        originalPrice: pricesJapan.english.beginner.originalPrice.jpy,
        popular: false,
        formLevel: "初級",
      },
      {
        level: "初中級",
        title: "英会話エレメンタリー",
        duration: "4〜5ヶ月",
        price: pricesJapan.english.elementary.offerPrice.jpy,
        originalPrice: pricesJapan.english.elementary.originalPrice.jpy,
        popular: false,
        formLevel: "中級",
      },
      {
        level: "中級",
        title: "英会話インターミディエイト",
        duration: "4〜5ヶ月",
        price: pricesJapan.english.intermediate.offerPrice.jpy,
        originalPrice: pricesJapan.english.intermediate.originalPrice.jpy,
        popular: false,
        formLevel: "上級",
      },
      {
        level: "セット割",
        title: "初級+初中級 セット",
        duration: "6〜8ヶ月",
        price: pricesJapan.english.beginnerElementaryCombo.offerPrice.jpy,
        originalPrice: pricesJapan.english.beginnerElementaryCombo.originalPrice.jpy,
        popular: true,
        formLevel: "初級",
      },
    ],
  },
};

export const JAPAN_FEATURES = [
  {
    icon: "🎥",
    title: "ライブオンライン授業",
    description: "リアルタイムの双方向レッスンで、どこからでも実践的に学べます。",
  },
  {
    icon: "🎓",
    title: "認定講師による指導",
    description: "経験豊富な講師が、確実に結果につながる指導を行います。",
  },
  {
    icon: "👥",
    title: "少人数制クラス(最大10名)",
    description: "一人ひとりに目が届く環境で、質問や発話練習も安心です。",
  },
  {
    icon: "⏰",
    title: "柔軟なスケジュール",
    description: "朝・昼・夜からライフスタイルに合った時間帯を選べます。",
  },
];

export const JAPAN_STEPS = [
  {
    number: "1",
    title: "無料体験レッスンに申し込む",
    description: "下記フォームに入力し、実際の授業を体験してください。",
  },
  {
    number: "2",
    title: "コースとレベルを選択",
    description: "専任カウンセラーが目標に合ったコースをご提案します。",
  },
  {
    number: "3",
    title: "受講開始、そして資格取得へ",
    description: "ライブ授業で実践的に学び、修了証を取得できます。",
  },
];
